import React from 'react';
import Avatar from 'react-avatar';
import moment from 'moment';
import {
 Image,
 Badge,
} from 'react-bootstrap';
import { Link } from 'react-router';
import TourDates from './TourDates';
import TourState from './TourState';
import TourToday from './TourToday';

class TourBadge extends React.Component {
  render() {
    let image = <Avatar name={this.props.tour.name} color="#326a34" size={250} />;
    if (this.props.tour.image) {
      image = <Image src={this.props.tour.image} responsive />;
    }
    const archived = (this.props.tour.state === 'AR');
    return (
      <div className="col-sm-6 col-md-6 tour-container">
        <div className="tour">
          <Link to={`/tours/${this.props.tour.id}/overview`}>
            <div className="edit-overlay-container">
              <div className="background-test"></div>
              <div className="edit-overlay">
                <h3>Details</h3>
              </div>
            </div>
            <div className="tour-image">
              {image}
            </div>
            <div className="tour-name">
              <h3>{ this.props.tour.name }</h3>
              <h5>{ this.props.tour.tag_line }</h5>
            </div>
          </Link>
          <div className="tour-dates">
            <TourState state={this.props.tour.state} />&nbsp;
            { !archived && (
              <TourDates
                start={this.props.tour.start}
                end={this.props.tour.end}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default TourBadge;



// WEBPACK FOOTER //
// src/routes/tours/components/TourBadge.js